module.exports = __webpack_public_path__ + "static/media/headphones.02471044.png";